export default __webpack_public_path__ + "static/media/3EstudiantesIes_combinado_scroll.adc1802b.png";